(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentSeverityDialogController', IncidentSeverityDialogController);

    IncidentSeverityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IncidentSeverity', 'Corporation'];

    function IncidentSeverityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IncidentSeverity, Corporation) {
        var vm = this;

        vm.incidentSeverity = entity;
        vm.clear = clear;
        vm.save = save;
        vm.corporations = Corporation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.incidentSeverity.id !== null) {
                IncidentSeverity.update(vm.incidentSeverity, onSaveSuccess, onSaveError);
            } else {
                IncidentSeverity.save(vm.incidentSeverity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:incidentSeverityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
